/**
 * Gating for parcel Identify mode.
 *
 * Three concerns stay separate: the Parcels toggle only draws boundaries so
 * they can be traced over, the map canvas belongs to the geo tools, and
 * Identify is an explicit mode that must be the sole owner of a tap while it
 * is armed.
 */

/** Identify is offered on phones only, and only while boundaries are drawn. */
export function canOfferParcelIdentify({
  isPhone,
  parcelsVisible,
  lotSelectionOn,
  drawingMode
} = {}) {
  if (!isPhone || !parcelsVisible) return false;
  if (lotSelectionOn) return false;
  return (drawingMode || 'select') === 'select';
}

/** Armed Identify stands down as soon as anything else claims the tap. */
export function shouldExitParcelIdentify({ identifyOn, ...conditions } = {}) {
  if (!identifyOn) return false;
  return !canOfferParcelIdentify(conditions);
}

/**
 * Lot-selection needs its own on-map control on phones, where the parcels
 * sheet would otherwise own the finish action. Selection is armed from the
 * sheet, so the control follows the mode rather than gating it.
 */
export function canOfferLotSelect({ isPhone, lotSelectionOn } = {}) {
  return !!isPhone && !!lotSelectionOn;
}
